import { LATEX,PRECIO_INTROSA } from "../../../../../utility/constants";

/**
 * Obtiene los kilos secos de un ítem de compra.
 * @param {*} dato_actual - Ítem de compra
 * @returns {number} - Kilos secos calculados
 */
export const getKilosSecosFromItem = (dato_actual) => {
    return (dato_actual.kilos_ingresados.total * ((dato_actual.analisis[0] && dato_actual.analisis[0].drc_final) ? dato_actual.analisis[0].drc_final : 0));
}


/**
 * Obtiene el precio de venta basado en el tipo de precio y materia.
 * @param {*} dato_actual - Ítem de compra
 * @returns {number} - Precio de venta calculado
 */
export const getPrecioVenta = (dato_actual) => {
    if (dato_actual.tipo_precio === PRECIO_INTROSA) {
        if (dato_actual.tipo_materia === LATEX) {
            return (dato_actual.precios_latex.precio_kilogramo + dato_actual.diferencial_introsa);
        } else {
            return (dato_actual.precios_solido.precio_kilogramo + dato_actual.diferencial_introsa);
        }
    } else {
        return (dato_actual.precio_kilogramo_ersa);
    }
};
